import { ReactElement } from 'react';
import { PulseLoader } from 'react-spinners';

const Typing = (): ReactElement => {
  return <PulseLoader color="rgba(0, 0, 0, .6)" size="0.333rem" speedMultiplier={0.5} />;
};

export default Typing;
